import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/faqs/categories', { params })
  },
  store (formData) {
    return apiClient.post('/faqs/categories', formData)
  },
  show (id, params) {
    return apiClient.get(`/faqs/categories/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/faqs/categories/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/faqs/categories/${id}`)
  }
}
